import { render, staticRenderFns } from "./supplierRegistration.vue?vue&type=template&id=634e2b96&scoped=true"
import script from "./supplierRegistration.vue?vue&type=script&lang=js"
export * from "./supplierRegistration.vue?vue&type=script&lang=js"
import style0 from "./supplierRegistration.vue?vue&type=style&index=0&id=634e2b96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634e2b96",
  null
  
)

export default component.exports